import Paragraph from "@tiptap/extension-paragraph";

/**
 * Extension to preserve empty paragraphs in Markdown.
 *
 * We extend the standard Paragraph node to provide a custom renderMarkdown handler.
 * By default, @tiptap/markdown collapses consecutive empty paragraphs.
 * This handler ensures that empty paragraphs are serialized as `<br>`
 * to preserve the vertical space in the markdown output.
 */
export const EmptyParagraphExtension = Paragraph.extend({
  // @ts-ignore
  renderMarkdown(node: any, helpers: any) {
    if (!node.content || node.content.size === 0) {
      return "\u00A0";
    }

    return helpers.renderChildren(node);
  },
});
